import TrashSvg from '../assets/svg/Trash.js';
import EditSvg from '../assets/svg/Edit.js';
import SearchSvg from '../assets/svg/Search.js';
import PlusSvg from '../assets/svg/Plus.js';
import CloudDownloadSvg from '../assets/svg/CloudDownload.js';
import CheckSvg from '../assets/svg/Check.js';
import CloseSvg from '../assets/svg/Close.js';

export const userManagerQuery = {
  tags: 'tags',
};

export const userManagerConstants = {
  icons: {
    trashIcon: ({ size, color = '#6B7280', ...props }) => (
      <TrashSvg
        width={size || "14"}
        height={size || "14"}
        style={{ color: color }}
        {...props}
      />
    ),
    editIcon: ({ size, color = '#6B7280', ...props }) => (
      <EditSvg
        width={size || "14"}
        height={size || "14"}
        style={{ color: color }}
        {...props}
      />
    ),
    searchIcon: ({ size, color = '#6B7280', ...props }) => (
      <SearchSvg
        width={size || "14"}
        height={size || "14"}
        style={{ color: color }}
        {...props}
      />
    ),
    plusIcon: ({ size, color = '#FFFFFF', ...props }) => (
      <PlusSvg
        width={size || "14"}
        height={size || "14"}
        style={{ color: color }}
        {...props}
      />
    ),
    cloudDownloadIcon: ({ size, color = '#6B7280', ...props }) => (
      <CloudDownloadSvg
        width={size || "14"}
        height={size || "14"}
        style={{ color: color }}
        {...props}
      />
    ),
    checkIcon: ({ size, color = '#10B981', ...props }) => (
      <CheckSvg
        width={size || "14"}
        height={size || "14"}
        style={{ color: color, ...props.style }}
        {...props}
      />
    ),
    closeIcon: ({ size, color = '#9CA3AF', ...props }) => (
      <CloseSvg
        width={size || "14"}
        height={size || "14"}
        style={{ color: color, ...props.style }}
        {...props}
      />
    )
  },
  userListingMessages: {
    title: "Users List",
    searchPlaceholder: "Search...",
    emptyMessage: "No users found...",
    loadingMessage: "Loading users...",
    fetchErrorDesc: "Something went wrong, failed to load users.",
    createUserButton: "Create User",
    cancelButton: "Cancel",
    confirmButton: "Yes, Proceed",
    deleteSuccessTitle: "User Deleted",
    deleteSuccessDesc: "User successfully deleted.",
    deleteErrorTitle: "Unable to delete user",
    statusSuccessTitle: "Status Updated",
    statusSuccessDesc: "Status successfully updated.",
    statusErrorTitle: "Unable to update status",
    defaultErrorDesc: "Something went wrong, please try again later.",
    deleteConfirmHeader: "Delete User",
    deleteConfirmContent: (name) => `Are you sure you want to delete user ${name}?`,
    statusConfirmHeader: "Change User Status",
    statusConfirmContent: (name) => `Are you sure you want to change the status of ${name}?`,
  },
  userListingTableHeaders: {
    name: "NAME",
    email: "E-MAIL",
    role: "ROLE",
    status: "STATUS",
    actions: "ACTIONS"
  },
  roleListingMessages: {
    title: "User Roles",
    searchPlaceholder: "Search Roles...",
    emptyMessage: "No roles found...",
    loadingMessage: "Loading roles...",
    fetchErrorDesc: "Something went wrong, failed to load roles.",
    createRoleButton: "Create Role",
    cancelButton: "Cancel",
    confirmButton: "Yes, Proceed",
    deleteSuccessTitle: "Role Deleted",
    deleteSuccessDesc: "Role successfully deleted.",
    deleteErrorTitle: "Unable to delete role",
    statusSuccessTitle: "Status Updated",
    statusSuccessDesc: "Role status successfully updated.",
    statusErrorTitle: "Unable to update status",
    defaultErrorDesc: "Something went wrong, please try again later.",
    deleteConfirmHeader: "Delete Role",
    deleteConfirmContent: (name) => `Are you sure you want to delete role ${name}?`,
    statusConfirmHeader: "Change Role Status",
    statusConfirmContent: (name) => `Are you sure you want to change the status of ${name}?`,
  },
  roleListingTableHeaders: {
    name: "ROLE NAME",
    description: "DESCRIPTION",
    permissions: "PERMISSIONS",
    status: "STATUS",
    actions: "ACTIONS"
  },
  createUserModal: {
    labels: {
      name: "Name of User",
      email: "E-Mail",
      mobile: "Mobile No",
      countryCode: "Country Code",
      password: "Password",
      retypePassword: "Re-Type Password",
      gender: "Gender",
      dob: "Date of Birth",
      role: "Assign Role",
    },
    placeholders: {
      name: "Enter name of the user",
      email: "Enter Email Id",
      mobile: "Enter Mobile Number",
      password: "Enter Password",
      retypePassword: "Enter Password Again",
      dob: "01 Jan 1993",
      countryCode: "Country Code",
      gender: "Select Gender",
    },
    genderOptions: [
      { id: 'NOT_SHARED', label: "Don't Prefer to Share" },
      { id: 'MALE', label: 'Male' },
      { id: 'FEMALE', label: 'Female' },
    ],
    // TODO: Replace this static list with a dynamic fetch from the country codes API
    countryCodes: [
      { id: '+1', label: '+1 (USA/Canada)' },
      { id: '+1876', label: '+1876 (Jamaica)' },
      { id: '+20', label: '+20 (Egypt)' },
      { id: '+230', label: '+230 (Mauritius)' },
      { id: '+234', label: '+234 (Nigeria)' },
      { id: '+237', label: '+237 (Cameroon)' },
      { id: '+249', label: '+249 (Sudan)' },
      { id: '+254', label: '+254 (Kenya)' },
      { id: '+27', label: '+27 (South Africa)' },
      { id: '+34', label: '+34 (Spain)' },
      { id: '+36', label: '+36 (Hungary)' },
      { id: '+357', label: '+357 (Cyprus)' },
      { id: '+44', label: '+44 (UK)' },
      { id: '+49', label: '+49 (Germany)' },
      { id: '+52', label: '+52 (Mexico)' },
      { id: '+502', label: '+502 (Guatemala)' },
      { id: '+506', label: '+506 (Costa Rica)' },
      { id: '+592', label: '+592 (Guyana)' },
      { id: '+60', label: '+60 (Malaysia)' },
      { id: '+61', label: '+61 (Australia)' },
      { id: '+62', label: '+62 (Indonesia)' },
      { id: '+63', label: '+63 (Philippines)' },
      { id: '+64', label: '+64 (New Zealand)' },
      { id: '+65', label: '+65 (Singapore)' },
      { id: '+66', label: '+66 (Thailand)' },
      { id: '+673', label: '+673 (Brunei)' },
      { id: '+81', label: '+81 (Japan)' },
      { id: '+84', label: '+84 (Vietnam)' },
      { id: '+852', label: '+852 (Hong Kong)' },
      { id: '+91', label: '+91 (India)' },
      { id: '+94', label: '+94 (Sri Lanka)' },
      { id: '+961', label: '+961 (Lebanon)' },
      { id: '+962', label: '+962 (Jordan)' },
      { id: '+965', label: '+965 (Kuwait)' },
      { id: '+966', label: '+966 (Saudi Arabia)' },
      { id: '+968', label: '+968 (Oman)' },
      { id: '+971', label: '+971 (UAE)' },
      { id: '+973', label: '+973 (Bahrain)' },
      { id: '+974', label: '+974 (Qatar)' },
      { id: '+975', label: '+975 (Bhutan)' },
      { id: '+977', label: '+977 (Nepal)' },
      { id: '+92', label: '+92 (Pakistan)' },
      { id: '+93', label: '+93 (Afghanistan)' },
      { id: '+960', label: '+960 (Maldives)' },
    ],
    passwordHints: [
      'Password must be minimum 8 characters long.',
      'Password must include at least one lower case (a) and one upper case (A).',
      'Password must include at least one number and one symbol (!@#$%^&*()_+).',
    ],
    // Navigation configuration — mirrors OutletCreateModal NAV structure
    // Each top-level entry is a collapsible category; subcategories map to scrollable sections.
    navConfig: [
      {
        id: 1,
        name: 'Basic',
        slug: 'basic',
        subcategories: [
          { id: 11, name: 'Basic Information', slug: 'basic-information' },
          { id: 12, name: 'Brand Access', slug: 'brand-access' },
          { id: 13, name: 'Assign Role', slug: 'assign-role' },
        ],
      },
      {
        id: 2,
        name: 'Advanced',
        slug: 'advanced',
        subcategories: [
          { id: 21, name: 'Permissions', slug: 'permissions' },
          // TODO: Add communications section when feature is ready
          // { id: 22, name: 'Communications', slug: 'communications' },
        ],
      },
    ],
    slug: {
      BASIC_INFORMATION: 'basic-information',
      BRAND_ACCESS: 'brand-access',       
      ASSIGN_ROLE: 'assign-role',
      PERMISSIONS: 'permissions',
      // COMMUNICATIONS: 'communications',    // TODO: uncomment when ready
    },
    hashPrefix: 'user',
    defaultSlug: 'basic-information',
    sectionTitles: {
      basicInformation: {
        outer: 'Basic Information',
      },
      brandAccess: {
        outer: 'Brand Access',
        inner: 'Select your brands to give access',
        button: 'Choose Brands',
        editButton: 'Edit Brand Access',
        emptySelection: 'No brands selected.',
        saveButton: 'Save',
        cancelButton: 'Cancel',
        loadingMessage: 'Loading brands...',
        searchPlaceholder: 'Search Brands',
        searchChildPlaceholder: 'Search Outlets',
        childNoDataMessage: 'No outlet exists',
        fallbackBrandName: (brandId) => `Brand ${brandId}`,
        allBrandsLabel: 'All Brands',
        allOutletsLabel: 'All Outlets',
        emptyTableMessage: 'No brand access selected.',
        tableHeaders: {
          brandName: 'Brand Name',
          outletsSelected: 'Outlets Selected',
        }
      },
      assignRole: {
        outer: 'Assign Role',
        placeholder: 'Select Role',
        searchPlaceholder: 'Search Roles',
        emptySelection: 'No role assigned.',
        detailsHeader: 'Selected Role Details',
        labels: {
          roleName: 'Role Name',
          description: 'Description',
          totalPermissions: 'Total Permissions',
          roleStatus: 'Role Status',
          active: 'Active',
          inactive: 'Inactive',
        },
        modalHeader: 'Role Permissions',
        loadingMessage: 'Loading permissions...',
        emptyPermissions: 'No permissions found for this role.',
        toastMessages: {
          deleteSuccessTitle: 'Role Deleted',
          deleteSuccessDesc: 'Role deleted successfully from user.',
          deleteErrorTitle: 'Delete Failed',
          deleteErrorDesc: 'Failed to delete role from user.',
          removeSuccessTitle: 'Role Removed',
          removeSuccessDesc: 'Role removed from selection.',
        },
        tableHeaders: {
          productName: 'PRODUCT NAME',
          featureName: 'FEATURE NAME',
          permission: 'PERMISSION',
        }
      },
      permissions: {
        outer: 'Permissions',
        inner: 'Select permissions to assign',
        button: 'Choose Permissions',
        editButton: 'Edit Permissions',
        emptySelection: 'No permissions selected.',
        saveButton: 'Save',
        cancelButton: 'Cancel',
        emptyTableMessage: 'No permissions assigned.',
        searchPlaceholder: 'Search Products',
        searchChildPlaceholder: 'Search Permissions',
        childNoDataMessage: 'No permission exists',
        toastMessages: {
          deleteSuccessTitle: 'Permission Deleted',
          deleteSuccessDesc: 'Permission deleted successfully from user.',
          deleteErrorTitle: 'Delete Failed',
          deleteErrorDesc: 'Failed to delete permission from user.',
          removeSuccessTitle: 'Permission Removed',
          removeSuccessDesc: 'Permission removed from selection.',
        },
        tableHeaders: {
          productName: 'PRODUCT NAME',
          featureName: 'FEATURE NAME',
          permission: 'PERMISSION',
          actions: 'ACTIONS',
        }
      },
    },
    successMessages: {
      createTitle: 'User Created',
      createDesc: 'User has been successfully created.',
      editTitle: 'User Updated',
      editDesc: 'User has been successfully updated.',
    },
    errorMessages: {
      createTitle: 'Failed to Create User',
      createDesc: 'Something went wrong. Please try again.',
      userExistsDesc: 'A user with this email or mobile already exists.',
      editTitle: 'Failed to Update User',
      editDesc: 'Something went wrong. Please try again.',
      // Per-API failure messages shown individually when a secondary call fails
      brandAccessTitle: 'Brand Access Update Failed',
      brandAccessDesc: 'User was saved but brand access could not be updated. Please try again via Edit.',
      roleTitle: 'Role Assignment Failed',
      roleDesc: 'User was saved but role could not be assigned. Please try again via Edit.',
      permissionsTitle: 'Permissions Update Failed',
      permissionsDesc: 'User was saved but permissions could not be updated. Please try again via Edit.',
      requiredField: 'This field is required.',
      invalidEmail: 'Please enter a valid email address.',
      invalidMobile: 'Please enter a valid 10-digit mobile number.',
      passwordMismatch: 'Passwords do not match.',
      passwordWeak: 'Password does not meet the required criteria.',
    },
    modalHeader: {
      create: 'Create User',
      edit: 'Edit User',
    },
    deleteConfirm: {
      permission: {
        header: "Delete Permission",
        content: "Are you sure you want to delete this Permission from the User?",
        cancelButton: "No, Cancel!",
        confirmButton: "Yes, delete it!"
      },
      roleAssignment: {
        header: "Delete Role Assignment",
        content: "Are you sure you want to delete this Role Assignment from the User?",
        cancelButton: "No, Cancel!",
        confirmButton: "Yes, delete it!"
      }
    },
    unsavedChangesConfirm: {
      title: "Unsaved Changes",
      message: "You have unsaved changes. Are you sure you want to close? Any unsaved changes will be lost.",
      discardButton: "Discard",
    }
  },
  createRoleModal: {
    labels: {
      name: "Role Name",
      description: "Description",
    },
    placeholders: {
      name: "Enter role name",
      description: "Enter role description",
    },
    navConfig: [
      {
        id: 1,
        name: 'Basic',
        slug: 'basic',
        subcategories: [
          { id: 11, name: 'Basic Information', slug: 'basic-information' },
          { id: 12, name: 'Brand Access', slug: 'brand-access' },
        ],
      },
      {
        id: 2,
        name: 'Advanced',
        slug: 'advanced',
        subcategories: [
          { id: 21, name: 'Permissions', slug: 'permissions' },
        ],
      },
    ],
    slug: {
      BASIC_INFORMATION: 'basic-information',
      BRAND_ACCESS: 'brand-access',       
      PERMISSIONS: 'permissions',
    },
    hashPrefix: 'role',
    defaultSlug: 'basic-information',
    sectionTitles: {
      basicInformation: {
        outer: 'Basic Information',
      },
      brandAccess: {
        outer: 'Brand Access',
        inner: 'Select brand to give access',
        button: 'Choose Brand',
        placeholder: 'Select Brand',
        searchPlaceholder: 'Search Brands',
        emptySelection: 'No brand selected.',
        detailsTitle: 'Selected Brand Details',
        labels: {
          brandName: 'Brand Name',
          brandId: 'Brand ID',
        },
        allBrandsLabel: 'All Brands (Admin Access)',
      },
      permissions: {
        outer: 'Permissions',
        inner: 'Select permissions to assign',
        button: 'Choose Permissions',
        editButton: 'Edit Permissions',
        emptySelection: 'No permissions selected.',
        emptyTableMessage: 'No permissions assigned.',
        searchPlaceholder: 'Search Products',
        searchChildPlaceholder: 'Search Permissions',
        childNoDataMessage: 'No permission exists',
        toastMessages: {
          deleteSuccessTitle: 'Permission Deleted',
          deleteSuccessDesc: 'Permission deleted successfully from role.',
          deleteErrorTitle: 'Delete Failed',
          deleteErrorDesc: 'Failed to delete permission from role.',
          removeSuccessTitle: 'Permission Removed',
          removeSuccessDesc: 'Permission removed from selection.',
        },
        tableHeaders: {
          productName: 'PRODUCT NAME',
          featureName: 'FEATURE NAME',
          permission: 'PERMISSION',
          actions: 'ACTIONS',
        }
      },
    },
    successMessages: {
      createTitle: 'Role Created',
      createDesc: 'Role has been successfully created.',
      editTitle: 'Role Updated',
      editDesc: 'Role has been successfully updated.',
    },
    errorMessages: {
      createTitle: 'Failed to Create Role',
      createDesc: 'Something went wrong. Please try again.',
      editTitle: 'Failed to Update Role',
      editDesc: 'Something went wrong. Please try again.',
      requiredField: 'This field is required.',
    },
    modalHeader: {
      create: 'Create Role',
      edit: 'Edit Role',
    },
    loadingMessages: {
      create: 'Creating role...',
      loading: 'Loading role details...',
      update: 'Updating role...',
    },
    deleteConfirm: {
      permission: {
        header: 'Delete Permission',
        content: 'Are you sure you want to delete this Permission from the Role?',
        cancelButton: 'No, Cancel!',
        confirmButton: 'Yes, delete it!',
      }
    },
    unsavedChangesConfirm: {
      title: 'Unsaved Changes',
      message: 'You have unsaved changes. Are you sure you want to close? Any unsaved changes will be lost.',
      discardButton: 'Discard',
    }
  },
};
